export default __webpack_public_path__ + "static/media/conformation-green-tick-icon.013ef2b3.svg";